import React from "react";
import {Menu} from '@mantine/core';
import logo from '../../shared/assets/images/logoHeader.svg';
import {useScrollToSection} from "../../shared/hook/useScrollToSection";
import S from './Header.module.scss';
import {useNavigate} from "react-router-dom";

export const Header = () => {
  const scrollToSection = useScrollToSection();
  const navigate = useNavigate();

  return (
    <div className={S.header}>
      <div className={S.content}>
        <div className={S.picture} onClick={() => scrollToSection('banner')}>
          <img src={logo} alt="Logo"/>
        </div>

        <div className={S.button}>
          <Menu
              width={220}
              trigger="hover"
              openDelay={50}
              closeDelay={200}
              position="bottom-start"
              zIndex={1000}
              classNames={{
                itemLabel: S.menuItem
              }}>
            <Menu.Target>
              <div className={S.menuTarget}>
                продукты
              </div>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item onClick={() => scrollToSection('projects')}>
                БМК.ТОиР
              </Menu.Item>
              <Menu.Item onClick={() => scrollToSection('projects')}>
                БМК.ИТ
              </Menu.Item>
              <Menu.Item onClick={() => scrollToSection('projects')}>
                БМК.Платформа
              </Menu.Item>
              <Menu.Item onClick={() => scrollToSection('projects')}>
                БМК.ИИ-ассистенты
              </Menu.Item>
              <Menu.Item onClick={() => navigate('/product/Bench')}>
                Bench
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>

          <div onClick={() => scrollToSection('industries')} className={S.menuTarget}>решения</div>

          <Menu
            width={200}
            trigger="hover"
            openDelay={50}
            closeDelay={200}
            position="bottom-start"
            zIndex={1000}
            classNames={{
              itemLabel: S.menuItem
            }}>
            <Menu.Target>
              <div className={S.menuTarget}>
                о компании
              </div>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item onClick={() => scrollToSection('about')}>
                о нас
              </Menu.Item>
              <Menu.Item onClick={() => scrollToSection('contacts')}>
                контакты
              </Menu.Item>
              <Menu.Item onClick={() => navigate('/accreditation-page')}>
                ИТ-аккредитация
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </div>
      </div>
    </div>
  );
}
